import bizNodeModel from '../../bizNodeModel.mjs'
import BfType from './BfType.jsx'

export default bizNodeModel({
    bmCode: {
        name: () => '业务域',
    },

    bfDesc: {
        name: () => '简述',
    },

    bfMemo: {
        name: () => '备注',
    },

    bfName: {
        name: () => '流程名称',
        required: () => true,
    },

    bfTypeCode: {
        disabled: (map, node) => node.data.pkid,
        name: () => '流程类型',

        readableValue: (map, node) => {
            const {bfTypeCode} = node.data

            if (bfTypeCode) {
                const match = BfType.find(e => bfTypeCode === e[0])

                if (match) {
                    return match[1]
                }
            }

            return ''
        },

        required: () => true,
    },

    bfNo: {
        name: () => '流程代码',
        required: () => true,
    },

    pmCode: {
        name: () => '流程域',
    },
})
